/** @format */

import React, { useState } from 'react'
import { _$, Card } from '@king-design/react'
import { CustomPageContainer } from 'src/components'
import styled from 'styled-components'
import HeaderFilter from '../components/HeaderFilter'
import { ServiceOverviewSearchProps } from '../components/typescript.js'
import SessionContainer from './container'
import useNavRegion from 'src/hooks/useNavRegion'
import { initSearch } from '../components/constant'

const SessionAnalysis: React.FC<{ className?: string }> = ({ className }) => {
  const [headerSearch, setHeaderSearch] = useState<ServiceOverviewSearchProps>(initSearch())

  const region = useNavRegion()
  return (
    <div className={className}>
      <CustomPageContainer title={_$('会话分析')}>
        <Card type="none">
          <HeaderFilter
            value={headerSearch}
            onChange={val => {
              setHeaderSearch(val)
            }}
            showAggregate={false}
          />
          <div className="session-analysis-container">
            <SessionContainer region={region} headerSearch={headerSearch} />
          </div>
        </Card>
      </CustomPageContainer>
    </div>
  )
}

export default styled(SessionAnalysis)`
  .session-analysis-container {
    margin-top: 16px;
  }
`
